import { Flex } from 'foundations-components/components/Flex';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import useTestResultsData from '../hooks/useTestResultsData';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import ABVariations from '../components/testResults/ABVariations';
import Personalization from '../components/testResults/Personalization';
import PersonalizationResults from '../components/testResults/PersonalizationResults';
import { getHasMabAccess } from '../selectors';
import { useAppSelector } from '../reducers';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TestResultsContainer = () => {
  const {
    abTestId,
    mabExperimentId,
    mabRequestLoading,
    mabInfo,
    abVariants,
    abRequestLoading,
    hasMab,
    pastMabExperimentIds
  } = useTestResultsData();
  const hasMabAccess = useAppSelector(getHasMabAccess);

  // TODO: Redirect to base url if no mab access

  if ((mabExperimentId || pastMabExperimentIds && pastMabExperimentIds.length > 0) && !hasMabAccess && !abRequestLoading && (!abVariants || (abVariants === null || abVariants === void 0 ? void 0 : abVariants.length) === 0)) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      illustration: "keys",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-details-ui.testResults.mabNoAccessError.title"
      }),
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "page-details-ui.testResults.mabNoAccessError.message"
        })
      })
    });
  }
  if (mabExperimentId && mabRequestLoading || abTestId && abRequestLoading) {
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    });
  }

  // TODO: fix this
  if (abVariants && abVariants.length > 0) {
    // && languageVariation !== ALL_VARIATIONS;
    return /*#__PURE__*/_jsx(ABVariations, {
      abVariants: abVariants
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: hasMab && mabInfo ? /*#__PURE__*/_jsx(Personalization, {
      mabInfo: mabInfo
    }) : /*#__PURE__*/_jsx(PersonalizationResults, {
      pastMabExperimentIds: pastMabExperimentIds
    })
  });
};
export default TestResultsContainer;